var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _polygon123, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _path44, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _polygon169, _path59, _path60, _path61, _path62, _path63, _polygon170, _polygon171, _polygon172, _polygon173, _g3, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _line, _line2, _line3, _line4, _line5, _line6, _line7, _polygon174, _polygon175, _polygon176, _polygon177, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _polygon178, _path97;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLecturing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350.32 326.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.3;}.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-2,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-3,.cls-30,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9{fill:#060b0f;}.cls-2,.cls-89{opacity:0;}.cls-3{opacity:0.02;}.cls-4{opacity:0.04;}.cls-5{opacity:0.05;}.cls-6{opacity:0.07;}.cls-7{opacity:0.09;}.cls-8{opacity:0.11;}.cls-9{opacity:0.13;}.cls-10{opacity:0.14;}.cls-11{opacity:0.16;}.cls-12{opacity:0.18;}.cls-13{opacity:0.2;}.cls-14{opacity:0.21;}.cls-15{opacity:0.23;}.cls-16{opacity:0.25;}.cls-17{opacity:0.27;}.cls-18{opacity:0.29;}.cls-19{opacity:0.3;}.cls-20{opacity:0.32;}.cls-21{opacity:0.34;}.cls-22{opacity:0.36;}.cls-23{opacity:0.37;}.cls-24{opacity:0.39;}.cls-25{opacity:0.41;}.cls-26{opacity:0.43;}.cls-27{opacity:0.45;}.cls-28{opacity:0.46;}.cls-29{opacity:0.48;}.cls-30{opacity:0.5;}.cls-31{fill:url(#linear-gradient);}.cls-32{fill:url(#linear-gradient-2);}.cls-33{fill:url(#linear-gradient-3);}.cls-34{fill:url(#linear-gradient-4);}.cls-35{fill:url(#linear-gradient-5);}.cls-36{fill:url(#linear-gradient-6);}.cls-37{fill:url(#linear-gradient-7);}.cls-38{fill:url(#linear-gradient-8);}.cls-39{fill:url(#linear-gradient-9);}.cls-40{fill:url(#linear-gradient-10);}.cls-41{fill:#0a93ad;}.cls-42{fill:url(#linear-gradient-11);}.cls-43{fill:url(#linear-gradient-12);}.cls-44{fill:url(#linear-gradient-13);}.cls-45{fill:url(#linear-gradient-14);}.cls-46{fill:url(#linear-gradient-15);}.cls-47{fill:url(#linear-gradient-16);}.cls-48{fill:url(#linear-gradient-17);}.cls-49{fill:url(#linear-gradient-18);}.cls-50{fill:url(#linear-gradient-19);}.cls-51{fill:url(#linear-gradient-20);}.cls-52{fill:#cf4e20;}.cls-52,.cls-59{opacity:0.4;}.cls-53{fill:#fff;}.cls-54{fill:#ea505a;}.cls-55{fill:url(#linear-gradient-21);}.cls-56{fill:url(#linear-gradient-22);}.cls-57{fill:url(#linear-gradient-23);}.cls-58{fill:url(#linear-gradient-24);}.cls-59{fill:#353844;}.cls-60{fill:url(#linear-gradient-25);}.cls-61{fill:url(#linear-gradient-26);}.cls-62{fill:url(#linear-gradient-27);}.cls-63{fill:#d7d4cf;}.cls-64{fill:#b3b2af;}.cls-65{fill:url(#linear-gradient-28);}.cls-66{fill:url(#linear-gradient-29);}.cls-67{fill:url(#linear-gradient-30);}.cls-68{fill:url(#linear-gradient-31);}.cls-69{fill:url(#linear-gradient-32);}.cls-70{fill:url(#linear-gradient-33);}.cls-71{fill:#ddd;}.cls-72{fill:url(#linear-gradient-34);}.cls-73{fill:url(#linear-gradient-35);}.cls-74{fill:url(#linear-gradient-36);}.cls-75{fill:url(#linear-gradient-37);}.cls-76{fill:url(#linear-gradient-38);}.cls-77{fill:url(#linear-gradient-39);}.cls-78{fill:url(#linear-gradient-40);}.cls-79{fill:url(#linear-gradient-41);}.cls-80{fill:url(#linear-gradient-42);}.cls-81{fill:url(#linear-gradient-43);}.cls-82{fill:url(#linear-gradient-44);}.cls-83{fill:url(#linear-gradient-45);}.cls-84{fill:url(#linear-gradient-46);}.cls-85{fill:#e0efef;}.cls-86{fill:url(#linear-gradient-47);}.cls-87{fill:none;stroke:#fff;stroke-width:0.25px;opacity:0.6;}.cls-125,.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135,.cls-87{stroke-miterlimit:10;}.cls-88{opacity:0.23;}.cls-100,.cls-101,.cls-102,.cls-103,.cls-104,.cls-105,.cls-106,.cls-107,.cls-108,.cls-109,.cls-110,.cls-111,.cls-112,.cls-113,.cls-114,.cls-115,.cls-116,.cls-117,.cls-118,.cls-119,.cls-120,.cls-121,.cls-122,.cls-123,.cls-124,.cls-89,.cls-90,.cls-91,.cls-92,.cls-93,.cls-94,.cls-95,.cls-96,.cls-97,.cls-98,.cls-99{fill:#0f1425;}.cls-90{opacity:0.03;}.cls-91{opacity:0.06;}.cls-92{opacity:0.09;}.cls-93{opacity:0.11;}.cls-94{opacity:0.14;}.cls-95{opacity:0.17;}.cls-96{opacity:0.2;}.cls-97{opacity:0.23;}.cls-98{opacity:0.26;}.cls-99{opacity:0.29;}.cls-100{opacity:0.31;}.cls-101{opacity:0.34;}.cls-102{opacity:0.37;}.cls-103{opacity:0.4;}.cls-104{opacity:0.43;}.cls-105{opacity:0.46;}.cls-106{opacity:0.49;}.cls-107{opacity:0.51;}.cls-108{opacity:0.54;}.cls-109{opacity:0.57;}.cls-110{opacity:0.6;}.cls-111{opacity:0.63;}.cls-112{opacity:0.66;}.cls-113{opacity:0.69;}.cls-114{opacity:0.71;}.cls-115{opacity:0.74;}.cls-116{opacity:0.77;}.cls-117{opacity:0.8;}.cls-118{opacity:0.83;}.cls-119{opacity:0.86;}.cls-120{opacity:0.89;}.cls-121{opacity:0.91;}.cls-122{opacity:0.94;}.cls-123{opacity:0.97;}.cls-125{stroke:#6e6e6e;stroke-width:0.75px;fill:url(#linear-gradient-48);}.cls-126{fill:url(#linear-gradient-49);}.cls-127{fill:#b3b2b2;}.cls-128{fill:#fffefe;}.cls-129,.cls-130,.cls-131,.cls-132,.cls-133,.cls-134,.cls-135{stroke:#9a9999;}.cls-129{fill:url(#linear-gradient-50);}.cls-130{fill:url(#linear-gradient-51);}.cls-131{fill:url(#linear-gradient-52);}.cls-132{fill:url(#linear-gradient-53);}.cls-133{fill:url(#linear-gradient-54);}.cls-134{fill:url(#linear-gradient-55);}.cls-135{fill:url(#linear-gradient-56);}.cls-136{fill:url(#linear-gradient-57);}.cls-137{fill:url(#linear-gradient-58);}.cls-138{fill:url(#linear-gradient-59);}.cls-139{fill:url(#linear-gradient-60);}.cls-140{fill:#ded3cf;}.cls-141{fill:url(#linear-gradient-61);}.cls-142{fill:url(#linear-gradient-62);}.cls-143{fill:url(#linear-gradient-63);}.cls-144{fill:url(#linear-gradient-64);}.cls-145{fill:url(#linear-gradient-65);}.cls-146{fill:url(#linear-gradient-66);}.cls-147{fill:url(#linear-gradient-67);}.cls-148{fill:url(#linear-gradient-68);}.cls-149{fill:url(#linear-gradient-69);}.cls-150{fill:url(#linear-gradient-70);}.cls-151{fill:url(#linear-gradient-71);}.cls-152{fill:url(#linear-gradient-72);}.cls-153{fill:url(#linear-gradient-73);}.cls-154{fill:url(#linear-gradient-74);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -123.03,
    y1: 255.44,
    x2: -102.56,
    y2: 285.59,
    gradientTransform: "translate(282.27 94.53) scale(0.96 0.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#858585"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 226.18,
    y1: 362.06,
    x2: 247.34,
    y2: 362.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#686973"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111623"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 178.9,
    y1: 327.62,
    x2: 196.65,
    y2: 353.77,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 169.56,
    y1: 336.4,
    x2: 235.93,
    y2: 336.4,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -95.09,
    y1: 266.9,
    x2: -74.62,
    y2: 297.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -193.35,
    y1: 220.71,
    x2: -172.88,
    y2: 250.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 111.27,
    y1: 294.23,
    x2: 129.02,
    y2: 320.37,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -165.41,
    y1: 232.17,
    x2: -144.94,
    y2: 262.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 109.3,
    y1: 306.04,
    x2: 180.65,
    y2: 306.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -159.71,
    y1: 138.27,
    x2: -110.93,
    y2: 138.27,
    gradientTransform: "matrix(1, 0, -0.14, 0.97, 324.45, 71.46)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e0efef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82bae6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -214.97,
    y1: 174.31,
    x2: -166.19,
    y2: 174.31,
    xlinkHref: "#linear-gradient-10"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 116.23,
    y1: 184.83,
    x2: 134.57,
    y2: 184.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 164.25,
    y1: 219.08,
    x2: 199.19,
    y2: 219.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 486.8,
    y1: 1724.16,
    x2: 504.86,
    y2: 1724.16,
    gradientTransform: "matrix(1.07, 0.22, -0.22, 1.07, 30.91, -1785.91)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fad8d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0b5b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 160.86,
    y1: 155.11,
    x2: 186.61,
    y2: 155.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 101.57,
    y1: 264.32,
    x2: 250.53,
    y2: 264.32,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 101.57,
    y1: 261.45,
    x2: 250.53,
    y2: 261.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: -45.08,
    y1: 1072.28,
    x2: 15,
    y2: 1072.28,
    gradientTransform: "translate(329.91 -869.73) rotate(6.92)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8ab16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ea542d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 8.73,
    y1: 1035.52,
    x2: 18.78,
    y2: 1035.52,
    gradientTransform: "translate(329.91 -869.73) rotate(6.92)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: -17.56,
    y1: 1099.28,
    x2: -5.68,
    y2: 1099.28,
    gradientTransform: "translate(329.91 -869.73) rotate(6.92)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 191.13,
    y1: 1324.58,
    x2: 209.8,
    y2: 1324.58,
    gradientTransform: "matrix(1.03, 0.16, -0.16, 1.03, 114.98, -1213.97)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 97.04,
    y1: 184.22,
    x2: 127.53,
    y2: 184.22,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 155.51,
    y1: 244.52,
    x2: 165.81,
    y2: 244.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 126.41,
    y1: 249.04,
    x2: 141.22,
    y2: 249.04,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 71.48,
    y1: 104.75,
    x2: 94.91,
    y2: 104.75,
    gradientTransform: "translate(70.48 123.29) rotate(10.1)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 66.26,
    y1: 97.03,
    x2: 96.93,
    y2: 97.03,
    gradientTransform: "translate(70.48 123.29) rotate(10.1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 14319.39,
    y1: 228.56,
    x2: 14307.23,
    y2: 210.3,
    gradientTransform: "matrix(-1, 0, 0, 1, 14519.78, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3f1ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 14311.98,
    y1: 226.8,
    x2: 14290.65,
    y2: 194.75,
    gradientTransform: "matrix(-1, 0, 0, 1, 14519.78, 0)",
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 222.6,
    y1: 294.04,
    x2: 182.88,
    y2: 287.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcece"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 225.39,
    y1: 276.7,
    x2: 185.67,
    y2: 270.3,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 175.17,
    y1: 289.21,
    x2: 226.67,
    y2: 289.21,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 192.4,
    y1: 273.94,
    x2: 237.75,
    y2: 273.94,
    xlinkHref: "#linear-gradient-29"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 108.81,
    y1: 208.67,
    x2: 150.3,
    y2: 208.67,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 223.22,
    y1: 263.18,
    x2: 232.47,
    y2: 263.18,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 102.95,
    y1: 312.98,
    x2: 102.95,
    y2: 282.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3afa8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e9e8e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 107.1,
    y1: 314.47,
    x2: 105.23,
    y2: 317.33,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 144.82,
    y1: 280.57,
    x2: 175.01,
    y2: 280.57,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 166,
    y1: 301.88,
    x2: 229.85,
    y2: 301.88,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 183.35,
    y1: 277.74,
    x2: 202.05,
    y2: 277.74,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-14"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 159.12,
    y1: 280.48,
    x2: 202.19,
    y2: 280.48,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 170.58,
    y1: 346.37,
    x2: 170.58,
    y2: 315.43,
    xlinkHref: "#linear-gradient-35"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 174.72,
    y1: 347.87,
    x2: 172.86,
    y2: 350.73,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 14647.38,
    y1: 234.37,
    x2: 14657.83,
    y2: 247.29,
    gradientTransform: "matrix(-1, 0, 0, 1, 14837.48, 0)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 14665.27,
    y1: 225.04,
    x2: 14665.15,
    y2: 225,
    gradientTransform: "matrix(-1, 0, 0, 1, 14837.48, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e2e1e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f4f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 14676.87,
    y1: 238.6,
    x2: 14647.35,
    y2: 227.36,
    gradientTransform: "matrix(-1, 0, 0, 1, 14837.48, 0)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 14677.64,
    y1: 241.59,
    x2: 14661.18,
    y2: 235.32,
    gradientTransform: "matrix(-1, 0, 0, 1, 14837.48, 0)",
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 14665.27,
    y1: 219.97,
    x2: 14665.15,
    y2: 219.93,
    xlinkHref: "#linear-gradient-44"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 301.95,
    y1: 232.51,
    x2: 343.76,
    y2: -22.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 312.76,
    y1: 111.09,
    x2: 322.6,
    y2: 51.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cabde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#293479"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 319.01,
    y1: 355.34,
    x2: 297.46,
    y2: 373.55,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 319.01,
    y1: 362.04,
    x2: 297.46,
    y2: 380.25,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 319.01,
    y1: 368.73,
    x2: 297.46,
    y2: 386.94,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 319.01,
    y1: 375.43,
    x2: 297.46,
    y2: 393.64,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 319.01,
    y1: 382.13,
    x2: 297.46,
    y2: 400.34,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 319.01,
    y1: 388.82,
    x2: 297.46,
    y2: 407.03,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 319.01,
    y1: 395.52,
    x2: 297.46,
    y2: 413.73,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    xlinkHref: "#linear-gradient-49"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 305.22,
    y1: 353.75,
    x2: 305.22,
    y2: 386.68,
    gradientTransform: "matrix(1, 0.46, 0, 1, -85.79, -458.05)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e55251"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5c398e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 315.32,
    y1: 353.75,
    x2: 315.32,
    y2: 386.68,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 325.43,
    y1: 353.75,
    x2: 325.43,
    y2: 386.68,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 335.53,
    y1: 353.75,
    x2: 335.53,
    y2: 386.68,
    xlinkHref: "#linear-gradient-57"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 355.37,
    y1: 154.58,
    x2: 384.75,
    y2: 192.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4158a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 365.1,
    y1: 301.67,
    x2: 388.85,
    y2: 302.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#19203c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#154778"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 393.26,
    y1: 310.49,
    x2: 415.86,
    y2: 311.5,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 343.97,
    y1: 155.42,
    x2: 336.16,
    y2: 159.71,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 335.48,
    y1: 170.64,
    x2: 348.15,
    y2: 171.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f4a6a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fad6d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 395.62,
    y1: 252.06,
    x2: 378.49,
    y2: 254.48,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 416.57,
    y1: 261.84,
    x2: 394.64,
    y2: 261.84,
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 413.96,
    y1: 189.46,
    x2: 383.15,
    y2: 183.93,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 402,
    y1: 182.83,
    x2: 437.09,
    y2: 194.13,
    xlinkHref: "#linear-gradient-61"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 405.54,
    y1: 148.24,
    x2: 387.09,
    y2: 148.24,
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 409.15,
    y1: 132.57,
    x2: 393.44,
    y2: 141.19,
    xlinkHref: "#linear-gradient-65"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 417.29,
    y1: 138.88,
    x2: 377.33,
    y2: 137.65,
    gradientTransform: "translate(-7.55 11.7) rotate(-2.64)",
    xlinkHref: "#linear-gradient-62"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 306.6,
    y1: 146.42,
    x2: 306.31,
    y2: 109.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6cabde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#436eb4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 384.52,
    y1: 212.05,
    x2: 399.94,
    y2: 212.75,
    xlinkHref: "#linear-gradient-65"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ilustracija 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 109.77,
    cy: 308.5,
    rx: 33.29,
    ry: 16.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 109.77,
    cy: 308.5,
    rx: 32.64,
    ry: 16.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 109.77,
    cy: 308.5,
    rx: 31.98,
    ry: 15.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 109.77,
    cy: 308.5,
    rx: 31.33,
    ry: 15.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 109.77,
    cy: 308.5,
    rx: 30.68,
    ry: 15.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 109.77,
    cy: 308.5,
    rx: 30.03,
    ry: 14.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 109.77,
    cy: 308.5,
    rx: 29.37,
    ry: 14.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 109.77,
    cy: 308.5,
    rx: 28.72,
    ry: 14.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 109.77,
    cy: 308.5,
    rx: 28.07,
    ry: 13.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 109.77,
    cy: 308.5,
    rx: 27.41,
    ry: 13.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 109.77,
    cy: 308.5,
    rx: 26.76,
    ry: 13.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 109.77,
    cy: 308.5,
    rx: 26.11,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 109.77,
    cy: 308.5,
    rx: 25.45,
    ry: 12.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 109.77,
    cy: 308.5,
    rx: 24.8,
    ry: 12.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 109.77,
    cy: 308.5,
    rx: 24.15,
    ry: 12.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 109.77,
    cy: 308.5,
    rx: 23.49,
    ry: 11.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 109.77,
    cy: 308.5,
    rx: 22.84,
    ry: 11.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 109.77,
    cy: 308.5,
    rx: 22.19,
    ry: 11.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 109.77,
    cy: 308.5,
    rx: 21.53,
    ry: 10.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 109.77,
    cy: 308.5,
    rx: 20.88,
    ry: 10.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 109.77,
    cy: 308.5,
    rx: 20.23,
    ry: 10.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 109.77,
    cy: 308.5,
    rx: 19.57,
    ry: 9.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 109.77,
    cy: 308.5,
    rx: 18.92,
    ry: 9.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 109.77,
    cy: 308.5,
    rx: 18.27,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 109.77,
    cy: 308.5,
    rx: 17.61,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 109.77,
    cy: 308.5,
    rx: 16.96,
    ry: 8.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 109.77,
    cy: 308.5,
    rx: 16.31,
    ry: 8.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 109.77,
    cy: 308.5,
    rx: 15.65,
    ry: 7.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 109.77,
    cy: 308.5,
    rx: 15,
    ry: 7.46
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 33.29,
    cy: 271.48,
    rx: 33.29,
    ry: 16.57
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 33.29,
    cy: 271.48,
    rx: 32.64,
    ry: 16.24
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 33.29,
    cy: 271.48,
    rx: 31.98,
    ry: 15.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 33.29,
    cy: 271.48,
    rx: 31.33,
    ry: 15.59
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 33.29,
    cy: 271.48,
    rx: 30.68,
    ry: 15.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 33.29,
    cy: 271.48,
    rx: 30.03,
    ry: 14.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 33.29,
    cy: 271.48,
    rx: 29.37,
    ry: 14.62
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 33.29,
    cy: 271.48,
    rx: 28.72,
    ry: 14.29
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 33.29,
    cy: 271.48,
    rx: 28.07,
    ry: 13.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 33.29,
    cy: 271.48,
    rx: 27.41,
    ry: 13.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 33.29,
    cy: 271.48,
    rx: 26.76,
    ry: 13.32
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 33.29,
    cy: 271.48,
    rx: 26.11,
    ry: 12.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 33.29,
    cy: 271.48,
    rx: 25.45,
    ry: 12.67
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 33.29,
    cy: 271.48,
    rx: 24.8,
    ry: 12.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 33.29,
    cy: 271.48,
    rx: 24.15,
    ry: 12.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 33.29,
    cy: 271.48,
    rx: 23.49,
    ry: 11.69
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 33.29,
    cy: 271.48,
    rx: 22.84,
    ry: 11.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 33.29,
    cy: 271.48,
    rx: 22.19,
    ry: 11.04
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 33.29,
    cy: 271.48,
    rx: 21.53,
    ry: 10.72
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 33.29,
    cy: 271.48,
    rx: 20.88,
    ry: 10.39
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 33.29,
    cy: 271.48,
    rx: 20.23,
    ry: 10.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 33.29,
    cy: 271.48,
    rx: 19.57,
    ry: 9.74
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 33.29,
    cy: 271.48,
    rx: 18.92,
    ry: 9.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 33.29,
    cy: 271.48,
    rx: 18.27,
    ry: 9.09
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 33.29,
    cy: 271.48,
    rx: 17.61,
    ry: 8.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 33.29,
    cy: 271.48,
    rx: 16.96,
    ry: 8.44
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 33.29,
    cy: 271.48,
    rx: 16.31,
    ry: 8.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-29",
    cx: 33.29,
    cy: 271.48,
    rx: 15.65,
    ry: 7.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-30",
    cx: 33.29,
    cy: 271.48,
    rx: 15,
    ry: 7.46
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M161.77,343.89a2.84,2.84,0,0,0-1.62,2.46l-1.42,34.11.81-.36,2.54-32.51a2.6,2.6,0,0,1,1.49-2.15l23.49-10.93a2.1,2.1,0,0,1,2.93,1.42l6.19,26.75,1-.34-5.77-29.47a2.23,2.23,0,0,0-3.16-1.59Z",
    transform: "translate(-85.79 -65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M235.93,358.79s7.18-2.68,8-2.24,4.92,2.46,2.83,3.66-13.79,6.63-15.14,6.93-4.32,1.19-5.22-.67,1.18-5.83,1.18-5.83S231.29,363.56,235.93,358.79Z",
    transform: "translate(-85.79 -65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M215.42,343.13,187.36,356.2a1.66,1.66,0,0,1-.66.14,1.62,1.62,0,0,1-.65-.14l-23.36-11.05c-1.15-.54-2.25-3.22-1.11-3.77l30.86-12,23,10.62A1.74,1.74,0,0,1,215.42,343.13Z",
    transform: "translate(-85.79 -65)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M170.24,327.89s-2.79,10.74,3,13.68,9.22,8,19.8,2.83,29.23-13.73,30.28-12.89,4.29,29.13,4.29,29.13a3.58,3.58,0,0,0,5.35,1.15c3.56-2.2,2.93-3.77,2.93-3.77s1-39.13-5-41.2-12.35,0-12.35,0,6.81-5.17,3.77-6.08-8.05-.5-15.71,1-11.84.94-11.84.94Z",
    transform: "translate(-85.79 -65)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M188.64,354.91a2.86,2.86,0,0,0-1.62,2.46l-1.42,34.11.81-.36L189,358.61a2.57,2.57,0,0,1,1.49-2.15l23.49-10.93a2.1,2.1,0,0,1,2.93,1.42l6.2,26.75,1-.34-5.78-29.47a2.23,2.23,0,0,0-3.16-1.59Z",
    transform: "translate(-85.79 -65)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M94.14,310.5A2.84,2.84,0,0,0,92.52,313L91.1,347.07l.81-.37,2.54-32.51a2.61,2.61,0,0,1,1.49-2.14l23.5-10.94a2.09,2.09,0,0,1,2.92,1.43l6.2,26.75,1-.34-5.78-29.47a2.24,2.24,0,0,0-3.16-1.6Z",
    transform: "translate(-85.79 -65)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M147.79,309.73l-28.06,13.08a1.62,1.62,0,0,1-.65.14,1.58,1.58,0,0,1-.65-.14L95.06,311.76c-1.14-.55-2.24-3.22-1.11-3.78l30.87-12,23,10.63A1.73,1.73,0,0,1,147.79,309.73Z",
    transform: "translate(-85.79 -65)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M121,321.52a2.86,2.86,0,0,0-1.62,2.45L118,358.09l.81-.37,2.54-32.51a2.57,2.57,0,0,1,1.49-2.14l23.49-10.94a2.09,2.09,0,0,1,2.92,1.43l6.2,26.75,1-.34-5.78-29.48a2.24,2.24,0,0,0-3.16-1.59Z",
    transform: "translate(-85.79 -65)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M109.4,299.43s-.94,9.45,2.75,11.25,14.44,7.27,19.41,5.39,32.92-15.52,32.92-15.52l7.92,29.75s1.34,2.05,5.45,0,2.49-2.83,2.49-2.83-6.52-37-8.92-39.09-9.09-1.46-11.66.34,8.66-2.48,5.57-5.4-17.43-4.22-29,1.87S127.7,294,127.7,294Z",
    transform: "translate(-85.79 -65)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M164,184.31l-12.82,5.09c-3,1.5-4.67,4.71-4,7.59l5.11,22.64a5.69,5.69,0,0,0,2.88,3.79l6.14,3.32,31.38-9.57Z",
    transform: "translate(-85.79 -65)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M160.56,189.91l-6.36,2.91a4.2,4.2,0,0,0-2,4.34l4.67,20.93a2.73,2.73,0,0,0,1.13,1.66l9.11,6.16,13.68-3.35Z",
    transform: "translate(-85.79 -65)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M103.78,219.25,91,224.34a7.11,7.11,0,0,0-4,7.6l5.12,22.63a5.7,5.7,0,0,0,2.87,3.79l6.15,3.32,31.38-9.57Z",
    transform: "translate(-85.79 -65)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M100.31,224.85,94,227.76a4.21,4.21,0,0,0-2,4.34L96.58,253a2.69,2.69,0,0,0,1.12,1.66l9.12,6.16,13.68-3.35Z",
    transform: "translate(-85.79 -65)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M126.31,169.88a11.11,11.11,0,0,1,2.58,9.14c-.91,5.59-2.46,7.68,2.8,10.86s2.64,10.41-2.36,9.87-11.79-4.52-11.79-4.52-1.33-8.54-1.31-8.68S126.31,169.88,126.31,169.88Z",
    transform: "translate(-85.79 -65)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M164.34,214s-.76,7.56,2.14,9.55,15.61,6.5,15.61,6.5l17.1-11.81-11.6-10.1Z",
    transform: "translate(-85.79 -65)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M184.58,149.94s1.18,11.76.41,13.08-2.08,3.2-3,3.25a11,11,0,0,1-1.89-.09l1,5.48s-1.15,1.65-5.86,1.8-6.15-.63-6.15-.63-.08-12-.58-13.75-.51-10.52-.51-10.52Z",
    transform: "translate(-85.79 -65)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M185.94,149.91s-.18,2.68-5.82,3.41-7.27-1.21-7.27-1.21,1.94,3.67,1.4,4.48a5.07,5.07,0,0,0-.63,3.32c.19,1.15.09,1.37-.35,1.4s.08-2.75-1.7-3.07-1.71,1.37-1.2,2.77-.31,6.68-1.84,6.67-7.39-8.23-7.65-11.67,2.43-4,2.43-4-1.72-8.62,4.67-9.14,14.22-.76,16.62,1.71C185.85,145.88,187.59,147.36,185.94,149.91Z",
    transform: "translate(-85.79 -65)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M248.53,301.31l-77.76-37a3.79,3.79,0,0,1,0-6.83l67.32-31.56a3.29,3.29,0,0,0-.06-6l-26.66-12a9,9,0,0,0-7.66.14l-97.09,47.19a9.08,9.08,0,0,0,.23,16.39l106.86,49.06a8.87,8.87,0,0,0,7.55-.05l27.25-13A3.52,3.52,0,0,0,248.53,301.31Z",
    transform: "translate(-85.79 -65)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M248.53,298.44l-77.76-37a3.79,3.79,0,0,1,0-6.83L238.1,223a3.29,3.29,0,0,0-.06-6l-26.66-12a9,9,0,0,0-7.66.14l-97.09,47.19a9.08,9.08,0,0,0,.23,16.39l106.86,49.06a8.87,8.87,0,0,0,7.55-.05l27.25-13A3.52,3.52,0,0,0,248.53,298.44Z",
    transform: "translate(-85.79 -65)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M218.9,170.15s-7.43,11.88-10,15.79l-.63.92c-1.57,2.18-13.73-4.7-15.85-5.81l-.15-.07c-1.6-.81-1.69,29-1.69,29l-11.08,4.38,3.23,2.51s-.69-.44-2,2.2c-1.17,2.42-.54,3.33-.44,3.46l-20-10.69s-3.46-31.09-2.92-33.46,10.41-6.27,10.41-6.27c11.07,2.07,13.41-2.36,13.41-2.36s5.06-.94,7-.71,14.64,8.3,15.94,8.57,8.72-11.71,8.72-11.71.12,1,2.38,2.48A11.83,11.83,0,0,0,218.9,170.15Z",
    transform: "translate(-85.79 -65)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M213.27,166.66s.08-5.62.82-6.7,3-4.07,3-4.07a1.74,1.74,0,0,1,.46,2.26c-.68,1.52,4.13-8.38,5.07-8.07s-2.46,7.6-2.29,7.87,3.47,5.68,3,6.31-4.93,5.75-4.93,5.75A5.1,5.1,0,0,1,213.27,166.66Z",
    transform: "translate(-85.79 -65)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M182,217.11a5.77,5.77,0,0,1,3.93.06,12.21,12.21,0,0,1,3.06,1.9s-.18.3-1.65-.2-2.12.72.89,1.83,4.52,1.8,2.62,2.54-4.91,0-6.75-.59a23.68,23.68,0,0,1-4-1.78S179.64,217.69,182,217.11Z",
    transform: "translate(-85.79 -65)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M164.91,187.89s3.57,17.67,2.1,19.11a34.64,34.64,0,0,1-4,3.17s4.65-2.88,6.06-2.07,13.67,8.76,13.67,8.76-11.88-9.29-13.3-10S166.47,188.41,164.91,187.89Z",
    transform: "translate(-85.79 -65)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M208.87,185.94l-.63.92c-1.57,2.18-13.73-4.7-15.85-5.81l-.15-.07.14-4.57s6.25,6.06,11.17,8.08A20.05,20.05,0,0,0,208.87,185.94Z",
    transform: "translate(-85.79 -65)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M152.35,259.48l17.56-8.22a.89.89,0,0,0,0-1.6L144.36,238a3,3,0,0,0-2.56,0l-18,8.43Z",
    transform: "translate(-85.79 -65)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M145.39,228.55c-.79-2.52-7.09-31.73-10.09-34.42s-13.09,0-13.09,0-2.76,6.55-12.75,3c0,0-12.6,3.45-12.82,6.44s0,30.91,1.35,32c.49.38,5.81,2.29,9.39,4.33l.65,11.88,10.75-5.31a71.43,71.43,0,0,0,7.5,3.32,5.86,5.86,0,0,1,2.43-3.83c2.93-2.08,4.42-.89,4.42-.89l-6-3.34,7.74-3.21-2.25-23.86s7.5,21.06,9.25,22.35S155,244.32,155,244.32s0-2,2.67-2.92a21.15,21.15,0,0,1,3.1-.93S146.17,231.07,145.39,228.55Z",
    transform: "translate(-85.79 -65)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M126.22,174.55s-.57,2.56.18,3.71,1.28,5,.08,7.69-4.62,4.59-4.62,4.59l1.07,5s-.36,2.43-4.42,3.74-8.91-.64-8.91-.64-3.18-21.93-.27-24.07S126.22,174.55,126.22,174.55Z",
    transform: "translate(-85.79 -65)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M126.61,174.91s-1.62,4-7.58,5.1-7.52-1.13-7.52-1.13a9.73,9.73,0,0,1,1,7.1c-1.12,3.61-2,5.65-1.12,8s-1.76,4.73-1.76,4.73l-10,3.71s-5.46-4.65-.35-9.25,5.94-7.23,4.06-10.63-1.81-11.15,6.11-14.6,12.87-1.23,15.07.07,3.07,4.68,3.07,4.68S127.57,174.33,126.61,174.91Z",
    transform: "translate(-85.79 -65)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M155.51,242.92a3.88,3.88,0,0,1,2,2.13c.37,1.4.51,2.19,2.1,3.08s1.82.47.6-1.36-.09-3.26,1.5-1.35,1.3,3.13,2.94,2.85,1.54-2.52-.23-4.81a9.41,9.41,0,0,0-3.63-3S155.89,240.7,155.51,242.92Z",
    transform: "translate(-85.79 -65)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M131.55,244.65a37.74,37.74,0,0,1,5,2.57,10.39,10.39,0,0,0,2,1.36s-.4,1.12-2.31,0l-1.92-1.12s-.24,1.27,1.92,2.79,6.23,1.6,4.55,2.64-6.15.8-9.27-.8a50,50,0,0,1-5.14-3S128.75,243.84,131.55,244.65Z",
    transform: "translate(-85.79 -65)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M104.7,208.53s3.35,20.88,2,21.75-5.18,3-5.18,3,5.62-2.25,6.59-1.39,18.67,10.49,18.67,10.49-17.57-10.7-18.12-12.65S106.32,208.85,104.7,208.53Z",
    transform: "translate(-85.79 -65)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M130.45,200.68s6.38,4.34,4.76,7.85-2.59,6-2.59,6,7.77,19.88,8,20.38-6.71-20.61-6.29-21.2,3.66-5.54,2.3-7.75S130.45,200.68,130.45,200.68Z",
    transform: "translate(-85.79 -65)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M147.66,231s-.83,6.95-3,8.46a1.58,1.58,0,0,0-.91,1.88,14.78,14.78,0,0,1-1.67,6.42c-.81,1.08-2.68,3.93-4.16,4.08s-3.62-1.37-3.62-1.37l-2.41,5.47s-6-.67-8.43-3-2.78-3.94-2.78-3.94l4.17-11.84s11.59-10.93,12-10.92S147.66,231,147.66,231Z",
    transform: "translate(-85.79 -65)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M150.66,225.21c-.19,4.42-2.83,9-6,8.95l-3.18,0s-1,7.81-1.79,7.32-1.46-5.44-2.7-6.05-2.11,2.28-2,4.82-1,6.27-4.28,5.5-10-2.35-10.5-7.14-2.59-4.38-1-11.08,8.8-3.75,8.8-3.75-.34-5.3,6.56-3.62S150.66,225.21,150.66,225.21Z",
    transform: "translate(-85.79 -65)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M201.68,231.05l-17.57-8.22a.89.89,0,0,1,0-1.6l25.54-11.71a3.05,3.05,0,0,1,2.56,0l18,8.43Z",
    transform: "translate(-85.79 -65)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M201.68,230l-17.57-8.23a.88.88,0,0,1,0-1.59l25.54-11.72a3.05,3.05,0,0,1,2.56,0l18,8.43Z",
    transform: "translate(-85.79 -65)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "144.43 152.96 144.43 151.86 115.89 164.95 115.89 166.05 144.43 152.96"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.81 149.57 122.59 149.21 123.3 149.53 122.52 149.89 121.81 149.57"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.4 150.46 120.69 150.14 121.47 149.78 122.18 150.1 121.4 150.46"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.28 151.02 119.57 150.7 120.34 150.34 121.05 150.66 120.28 151.02"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.15 151.59 118.44 151.27 119.22 150.91 119.93 151.23 119.15 151.59"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.03 152.15 117.32 151.83 118.1 151.47 118.81 151.79 118.03 152.15"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.91 152.72 116.2 152.4 116.98 152.04 117.69 152.36 116.91 152.72"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.79 153.28 115.08 152.96 115.85 152.6 116.56 152.92 115.79 153.28"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.66 153.85 113.95 153.53 114.73 153.17 115.44 153.49 114.66 153.85"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.54 154.41 112.83 154.09 113.61 153.73 114.32 154.05 113.54 154.41"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.42 154.98 111.71 154.66 112.48 154.3 113.19 154.62 112.42 154.98"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "111.29 155.54 110.59 155.22 111.36 154.86 112.07 155.18 111.29 155.54"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.17 156.11 109.46 155.79 110.24 155.43 110.95 155.75 110.17 156.11"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "109.05 156.67 108.34 156.35 109.12 155.99 109.83 156.31 109.05 156.67"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "107.99 156.56 108.7 156.88 107.93 157.24 107.22 156.92 107.99 156.56"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.92 150.08 123.7 149.72 124.41 150.04 123.63 150.4 122.92 150.08"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "123.28 150.6 122.51 150.97 121.8 150.64 122.58 150.28 123.28 150.6"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.16 151.17 121.38 151.53 120.67 151.21 121.45 150.85 122.16 151.17"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.04 151.73 120.26 152.09 119.55 151.78 120.33 151.41 121.04 151.73"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.92 152.3 119.14 152.66 118.43 152.34 119.21 151.98 119.92 152.3"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.79 152.86 118.02 153.22 117.31 152.91 118.08 152.54 118.79 152.86"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.67 153.43 116.89 153.79 116.18 153.47 116.96 153.11 117.67 153.43"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.55 153.99 115.77 154.35 115.06 154.03 115.84 153.67 116.55 153.99"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.42 154.56 114.65 154.92 113.94 154.6 114.72 154.24 115.42 154.56"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.3 155.12 113.52 155.49 112.82 155.16 113.59 154.8 114.3 155.12"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.18 155.69 112.4 156.05 111.69 155.73 112.47 155.37 113.18 155.69"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.57 156.29 111.35 155.93 112.06 156.25 111.28 156.62 110.57 156.29"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "109.45 156.86 110.22 156.5 110.93 156.82 110.16 157.18 109.45 156.86"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "109.81 157.38 109.03 157.75 108.32 157.43 109.1 157.06 109.81 157.38"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "124.39 151.11 123.61 151.47 122.91 151.15 123.27 150.98 123.25 150.97 124.81 150.22 125.51 150.55 124.36 151.1 124.39 151.11"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.49 152.04 121.78 151.72 122.56 151.36 123.27 151.68 122.49 152.04"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.15 152.24 121.37 152.6 120.66 152.28 121.44 151.92 122.15 152.24"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.02 152.81 120.25 153.17 119.54 152.85 120.31 152.49 121.02 152.81"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.9 153.37 119.12 153.73 118.41 153.41 119.19 153.05 119.9 153.37"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.78 153.94 118 154.3 117.29 153.98 118.07 153.62 118.78 153.94"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.65 154.5 116.88 154.86 116.17 154.54 116.95 154.18 117.65 154.5"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.53 155.07 115.75 155.43 115.05 155.11 115.82 154.75 116.53 155.07"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.92 155.67 114.7 155.31 115.41 155.63 114.63 155.99 113.92 155.67"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.58 155.88 114.29 156.2 113.13 156.75 113.16 156.76 112.39 157.12 111.68 156.8 111.69 156.8 111.67 156.79 113.58 155.88"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.55 157.37 111.33 157.01 112.04 157.33 111.26 157.69 110.55 157.37"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.92 157.89 110.14 158.25 109.43 157.93 110.21 157.57 110.92 157.89"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "125.14 151.09 125.91 150.73 126.62 151.05 125.84 151.41 125.14 151.09"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "125.5 151.62 124.72 151.98 124.01 151.66 124.79 151.3 125.5 151.62"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "124.38 152.18 123.6 152.54 122.89 152.22 123.67 151.86 124.38 152.18"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "123.25 152.75 122.48 153.11 121.77 152.79 122.54 152.43 123.25 152.75"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.64 153.35 121.42 152.99 122.13 153.31 121.35 153.67 120.64 153.35"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.52 153.92 120.3 153.56 121.01 153.88 120.23 154.24 119.52 153.92"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.4 154.48 119.18 154.12 119.88 154.44 119.11 154.8 118.4 154.48"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.28 155.05 118.05 154.69 118.76 155.01 117.98 155.37 117.28 155.05"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.15 155.61 116.93 155.25 117.64 155.57 116.86 155.93 116.15 155.61"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.03 156.18 115.81 155.82 116.52 156.14 115.74 156.5 115.03 156.18"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.91 156.74 114.68 156.38 115.39 156.7 114.62 157.06 113.91 156.74"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.78 157.31 113.56 156.95 114.27 157.27 113.49 157.63 112.78 157.31"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "111.66 157.87 112.44 157.51 113.15 157.83 112.37 158.19 111.66 157.87"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.03 158.4 111.25 158.76 110.54 158.44 111.32 158.08 112.03 158.4"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "126.24 151.6 127.02 151.24 127.73 151.56 126.95 151.92 126.24 151.6"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "126.61 152.13 125.83 152.49 125.12 152.16 125.9 151.8 126.61 152.13"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "124 152.73 124.77 152.37 125.48 152.69 124.71 153.05 124 152.73"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.87 153.3 123.65 152.93 124.36 153.25 123.58 153.62 122.87 153.3"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.75 153.86 122.53 153.5 123.24 153.82 122.46 154.18 121.75 153.86"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.63 154.43 121.41 154.06 122.11 154.38 121.34 154.75 120.63 154.43"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.51 154.99 120.28 154.63 120.99 154.95 120.21 155.31 119.51 154.99"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.38 155.56 119.16 155.19 119.87 155.51 119.09 155.88 118.38 155.56"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.26 156.12 118.04 155.76 118.75 156.08 117.97 156.44 117.26 156.12"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.14 156.69 116.91 156.32 117.62 156.65 116.85 157.01 116.14 156.69"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.02 157.25 115.79 156.89 116.5 157.21 115.72 157.57 115.02 157.25"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.89 157.82 114.67 157.46 115.38 157.78 114.6 158.14 113.89 157.82"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.77 158.38 113.55 158.02 114.25 158.34 113.48 158.7 112.77 158.38"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.13 158.91 112.36 159.27 111.65 158.95 112.42 158.59 113.13 158.91"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "128.13 151.75 128.84 152.07 128.06 152.43 127.35 152.11 128.13 151.75"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "127 152.31 127.71 152.63 126.94 152.99 126.23 152.67 127 152.31"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.72 155.45 121.75 154.94 121.74 154.93 122.01 154.81 122.87 154.38 122.86 154.37 123.3 154.16 124 153.81 123.98 153.8 124.59 153.52 125.88 152.88 126.59 153.2 125.46 153.76 125.47 153.76 125.3 153.84 124.33 154.32 124.34 154.33 124.01 154.48 123.2 154.88 123.22 154.89 122.72 155.13 122.08 155.45 122.1 155.46 121.43 155.77 121.33 155.82 121.33 155.82 121.32 155.82 120.61 155.5 120.72 155.45"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.27 155.7 120.98 156.02 120.2 156.38 119.49 156.06 120.27 155.7"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.14 156.27 119.85 156.59 119.08 156.95 118.37 156.63 119.14 156.27"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.02 156.83 118.73 157.15 117.95 157.51 117.25 157.19 118.02 156.83"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.9 157.4 117.61 157.72 116.83 158.08 116.12 157.76 116.9 157.4"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.78 157.96 116.48 158.28 115.71 158.64 115 158.32 115.78 157.96"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.65 158.53 115.36 158.85 114.58 159.21 113.88 158.89 114.65 158.53"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.24 159.41 113.46 159.77 112.75 159.45 113.53 159.09 114.24 159.41"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M233.78,189.51c-6.07,2.73-22,10.41-26.46,12.58a2.77,2.77,0,0,0-1.51,1.87L200,227.83a1.14,1.14,0,0,0,1.6,1.3c5.88-2.84,22-10.58,26.59-12.6a2.74,2.74,0,0,0,1.58-1.88L235.54,191A1.27,1.27,0,0,0,233.78,189.51Z",
    transform: "translate(-85.79 -65)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M234.94,190.22c-6.06,2.73-22,10.41-26.46,12.58a2.79,2.79,0,0,0-1.51,1.87l-5.78,23.87a1.14,1.14,0,0,0,1.6,1.3c5.88-2.84,22-10.59,26.6-12.6a2.74,2.74,0,0,0,1.58-1.88l5.73-23.68A1.27,1.27,0,0,0,234.94,190.22Z",
    transform: "translate(-85.79 -65)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M115.26,249s25.06,10,26,11.81,11,19.6,11,19.6a5.83,5.83,0,0,1-4.24,4.34l-3.76,1.15-7.54-8.68-.9,22.37s-2.73,7.3-13.08,6.24-14.77-6.82-14.77-6.82l.9-20.1s-5.31,0-4.78-8S110.45,248.45,115.26,249Z",
    transform: "translate(-85.79 -65)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M118.59,250.36s1-2.2,1.67-2,11.2,3.62,12.2,5.16a6.09,6.09,0,0,1,.94,3.2Z",
    transform: "translate(-85.79 -65)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M226.67,294.59,192.4,277.73l-16.46,7.61a1.32,1.32,0,0,0,0,2.38l30.61,15a2.74,2.74,0,0,0,2.37,0Z",
    transform: "translate(-85.79 -65)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M192.4,277.73l34.27,16.86,10.92-22a1.52,1.52,0,0,0-.72-2.07l-31.75-14.72a1.69,1.69,0,0,0-2.22.77Z",
    transform: "translate(-85.79 -65)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M226.67,293.41,192.4,276.55l-16.46,7.6a1.32,1.32,0,0,0,0,2.38l30.61,15.06a2.74,2.74,0,0,0,2.37,0Z",
    transform: "translate(-85.79 -65)"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.26 214.72 109.05 214.16 107.94 214.66 109.16 215.22 110.26 214.72"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.91 216.1 112.01 215.6 110.8 215.04 109.7 215.54 110.91 216.1"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.66 216.98 113.76 216.48 112.55 215.92 111.45 216.42 112.66 216.98"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.41 217.86 115.51 217.36 114.3 216.8 113.2 217.3 114.41 217.86"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.16 218.74 117.26 218.25 116.05 217.68 114.95 218.18 116.16 218.74"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.91 219.63 119.02 219.13 117.8 218.56 116.7 219.06 117.91 219.63"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.66 220.51 120.77 220.01 119.55 219.44 118.45 219.94 119.66 220.51"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.41 221.39 122.52 220.89 121.31 220.32 120.2 220.82 121.41 221.39"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "123.16 222.27 124.27 221.77 123.06 221.21 121.95 221.71 123.16 222.27"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "124.91 223.15 126.02 222.65 124.81 222.09 123.7 222.59 124.91 223.15"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "126.66 224.03 127.77 223.53 126.56 222.97 125.45 223.47 126.66 224.03"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "128.41 224.91 129.52 224.41 128.31 223.85 127.2 224.35 128.41 224.91"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "130.16 225.79 131.27 225.29 130.06 224.73 128.95 225.23 130.16 225.79"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "131.81 225.61 130.7 226.11 131.92 226.67 133.02 226.18 131.81 225.61"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "108.53 215.51 107.32 214.95 106.22 215.45 107.43 216.01 108.53 215.51"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "107.97 216.33 109.18 216.89 110.29 216.39 109.07 215.83 107.97 216.33"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "109.72 217.21 110.93 217.77 112.04 217.27 110.83 216.71 109.72 217.21"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "111.47 218.09 112.68 218.65 113.79 218.15 112.58 217.59 111.47 218.09"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.22 218.97 114.43 219.53 115.54 219.03 114.33 218.47 113.22 218.97"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.97 219.85 116.18 220.42 117.29 219.92 116.08 219.35 114.97 219.85"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.72 220.73 117.93 221.3 119.04 220.8 117.83 220.23 116.72 220.73"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.47 221.62 119.69 222.18 120.79 221.68 119.58 221.12 118.47 221.62"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.22 222.5 121.44 223.06 122.54 222.56 121.33 222 120.22 222.5"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.97 223.38 123.19 223.94 124.29 223.44 123.08 222.88 121.97 223.38"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "123.72 224.26 124.94 224.82 126.04 224.32 124.83 223.76 123.72 224.26"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "127.79 225.2 126.58 224.64 125.48 225.14 126.69 225.7 127.79 225.2"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "129.54 226.08 128.33 225.52 127.23 226.02 128.44 226.58 129.54 226.08"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "128.98 226.9 130.19 227.47 131.29 226.97 130.08 226.4 128.98 226.9"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "106.24 217.12 107.45 217.68 108.56 217.18 107.99 216.92 108.03 216.9 105.6 215.74 104.49 216.24 106.29 217.1 106.24 217.12"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "109.2 218.56 110.31 218.06 109.1 217.5 107.99 218 109.2 218.56"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "109.74 218.88 110.96 219.44 112.06 218.94 110.85 218.38 109.74 218.88"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "111.5 219.76 112.71 220.32 113.81 219.83 112.6 219.26 111.5 219.76"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.25 220.64 114.46 221.21 115.56 220.71 114.35 220.14 113.25 220.64"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115 221.52 116.21 222.09 117.31 221.59 116.1 221.03 115 221.52"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.75 222.41 117.96 222.97 119.06 222.47 117.85 221.91 116.75 222.41"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "118.5 223.29 119.71 223.85 120.81 223.35 119.6 222.79 118.5 223.29"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.56 224.23 121.35 223.67 120.25 224.17 121.46 224.73 122.56 224.23"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "123.1 224.55 122 225.05 123.8 225.91 123.75 225.93 124.96 226.49 126.07 225.99 126.05 225.98 126.08 225.97 123.1 224.55"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "127.82 226.87 126.61 226.31 125.5 226.81 126.71 227.37 127.82 226.87"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "127.25 227.69 128.46 228.25 129.57 227.76 128.36 227.19 127.25 227.69"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "105.08 217.09 103.87 216.53 102.77 217.03 103.98 217.59 105.08 217.09"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "104.52 217.91 105.73 218.47 106.83 217.97 105.62 217.41 104.52 217.91"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "106.27 218.79 107.48 219.35 108.58 218.85 107.37 218.29 106.27 218.79"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "108.02 219.67 109.23 220.23 110.33 219.74 109.12 219.17 108.02 219.67"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.08 220.62 110.87 220.05 109.77 220.55 110.98 221.12 112.08 220.62"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.84 221.5 112.62 220.93 111.52 221.43 112.73 222 113.84 221.5"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.59 222.38 114.38 221.81 113.27 222.31 114.48 222.88 115.59 222.38"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.34 223.26 116.13 222.7 115.02 223.2 116.23 223.76 117.34 223.26"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.09 224.14 117.88 223.58 116.77 224.08 117.98 224.64 119.09 224.14"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.84 225.02 119.63 224.46 118.52 224.96 119.73 225.52 120.84 225.02"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.59 225.9 121.38 225.34 120.27 225.84 121.48 226.4 122.59 225.9"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "124.34 226.78 123.13 226.22 122.02 226.72 123.23 227.28 124.34 226.78"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "126.09 227.66 124.88 227.1 123.77 227.6 124.98 228.16 126.09 227.66"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "125.52 228.48 126.74 229.04 127.84 228.55 126.63 227.98 125.52 228.48"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "103.36 217.88 102.14 217.32 101.04 217.82 102.25 218.38 103.36 217.88"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "102.79 218.7 104 219.26 105.11 218.76 103.89 218.2 102.79 218.7"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "106.86 219.64 105.64 219.08 104.54 219.58 105.75 220.14 106.86 219.64"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "108.61 220.53 107.4 219.96 106.29 220.46 107.5 221.03 108.61 220.53"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "110.36 221.41 109.15 220.84 108.04 221.34 109.25 221.91 110.36 221.41"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.11 222.29 110.9 221.72 109.79 222.22 111 222.79 112.11 222.29"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.86 223.17 112.65 222.61 111.54 223.1 112.75 223.67 113.86 223.17"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "115.61 224.05 114.4 223.49 113.29 223.99 114.5 224.55 115.61 224.05"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.36 224.93 116.15 224.37 115.04 224.87 116.26 225.43 117.36 224.93"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.11 225.81 117.9 225.25 116.8 225.75 118.01 226.31 119.11 225.81"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "120.86 226.69 119.65 226.13 118.55 226.63 119.76 227.19 120.86 226.69"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.61 227.57 121.4 227.01 120.3 227.51 121.51 228.07 122.61 227.57"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "124.36 228.46 123.15 227.89 122.05 228.39 123.26 228.96 124.36 228.46"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "123.8 229.27 125.01 229.84 126.11 229.34 124.9 228.77 123.8 229.27"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "100.42 218.11 99.31 218.61 100.52 219.17 101.63 218.67 100.42 218.11"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "102.17 218.99 101.06 219.49 102.28 220.05 103.38 219.55 102.17 218.99"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "111.97 223.88 110.37 223.09 110.38 223.08 109.96 222.88 108.61 222.21 108.63 222.2 107.94 221.88 106.85 221.33 106.88 221.32 105.93 220.88 103.92 219.87 102.81 220.37 104.57 221.25 104.56 221.25 104.83 221.37 106.33 222.13 106.31 222.13 106.84 222.38 108.09 223 108.07 223.01 108.85 223.38 109.85 223.88 109.82 223.9 110.86 224.38 111.02 224.46 111.02 224.46 111.03 224.46 112.13 223.96 111.97 223.88"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "112.67 224.28 111.57 224.78 112.78 225.34 113.88 224.84 112.67 224.28"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "114.42 225.16 113.32 225.66 114.53 226.22 115.64 225.72 114.42 225.16"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "116.17 226.04 115.07 226.54 116.28 227.1 117.39 226.6 116.17 226.04"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "117.92 226.92 116.82 227.42 118.03 227.98 119.14 227.48 117.92 226.92"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "119.67 227.8 118.57 228.3 119.78 228.86 120.89 228.37 119.67 227.8"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "121.43 228.68 120.32 229.18 121.53 229.75 122.64 229.25 121.43 228.68"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "122.07 230.06 123.28 230.63 124.39 230.13 123.18 229.56 122.07 230.06"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M192.4,276.55l34.27,16.86,10.92-22a1.51,1.51,0,0,0-.72-2.06l-31.75-14.73a1.69,1.69,0,0,0-2.22.78Z",
    transform: "translate(-85.79 -65)"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "150.3 205.78 149.14 208.1 140.14 226.22 108.81 210.81 117.26 193.78 118.58 191.13 150.3 205.78"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "113.88 213.3 121.81 197.13 142.06 206.32 134.07 223.23 113.88 213.3"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "150.3 205.78 149.14 208.1 117.37 193.55 118.58 191.13 150.3 205.78"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "131.65 203.78 131.34 204.41 122.75 200.47 123.07 199.81 131.65 203.78"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "136.07 208.47 135.75 209.09 121.66 202.62 121.99 201.96 136.07 208.47"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "135.27 210.15 134.96 210.78 120.87 204.31 121.19 203.65 135.27 210.15"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "134.48 211.84 134.16 212.47 120.07 206 120.4 205.34 134.48 211.84"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "128.62 211.23 128.31 211.86 119.28 207.68 119.61 207.03 128.62 211.23"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "130.11 213.88 129.79 214.51 118.48 209.37 118.81 208.72 130.11 213.88"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "129.31 215.57 129 216.2 117.69 211.06 118.02 210.41 129.31 215.57"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "125.8 216.06 125.49 216.68 116.89 212.75 117.22 212.09 125.8 216.06"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M225.24,270.53c-.34,0-2.88-2.29-1.72-6.35s3.15-3.8,3.15-3.8,2.56-7.54,4-7.11-2.23,8.45-1.51,9.43,3.78,4.21,3.27,5.76a24.13,24.13,0,0,1-2.94,4.64S228.57,270.87,225.24,270.53Z",
    transform: "translate(-85.79 -65)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M119.08,320V296l-5.66-16.43a6,6,0,0,0-3-3.39L89.89,265.88A2.12,2.12,0,0,0,87,268.5l7,18.85V308Z",
    transform: "translate(-85.79 -65)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M119.08,319.94v3a1.58,1.58,0,0,1-.65-.14L95.06,311.76c-1.14-.55-2.24-3.22-1.11-3.78Z",
    transform: "translate(-85.79 -65)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M151.67,281.6s14.75-5.13,16.29-6.51,4.38-2.95,5.26-1.74,3.55,4.69,0,5.31-3.92.18-7.41,1.95-14,7.3-16.09,7.6-4.9-2.82-4.9-2.82A11.47,11.47,0,0,0,151.67,281.6Z",
    transform: "translate(-85.79 -65)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M193.29,286s7.43,2.78,8.65,3.34,12.17.17,13.41-.7,8-17,8-17a3.17,3.17,0,0,1,4.55-.35c2.45,2.09,2,3.13,2,3.13s-8.51,22.62-11.5,24-15.23,0-15.23,0a3.12,3.12,0,0,1-1.19,3.42c-1.86,1.32-3.76,2.2-4.54,9.4a117.79,117.79,0,0,0,0,17.26s2.12,2.66-8.73,4.43-19-4.14-19.33-6.9,1.28-23,1.28-23-1.17,5.57-2,5.95-3.32-3.59-2.37-9.27a34.22,34.22,0,0,1,3.16-9.75Z",
    transform: "translate(-85.79 -65)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M200.64,268.41s1.77,4.06,1.35,5.59-.18,4.68-2.48,6.37a8.14,8.14,0,0,1-5.43,1.21,7.3,7.3,0,0,0-1.27,4.12c.06,2.35,0,1,0,1L183.35,285s2.92-6.83,3.67-7.8,5.22-7.95,5.22-7.95Z",
    transform: "translate(-85.79 -65)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M201.86,264c1,4.74-.28,7.21-3.9,9s-4.7.32-4.7.32,1.54,4.65-1.18,7.21-2.55,3.88-.74,8,.66,13.11-12.11,14.74-24-8.42-18.81-16.7,18.11-4.59,18.24-10.84-1.92-13.25,6.94-16.81S200.8,259,201.86,264Z",
    transform: "translate(-85.79 -65)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M186.7,353.34V329.41L181.05,313a6,6,0,0,0-3-3.39l-20.56-10.31a2.11,2.11,0,0,0-2.93,2.62l7,18.84v20.64Z",
    transform: "translate(-85.79 -65)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M186.7,353.34v3a1.62,1.62,0,0,1-.65-.14l-23.36-11.05c-1.15-.54-2.25-3.22-1.11-3.77Z",
    transform: "translate(-85.79 -65)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M178.32,241.59v3.19a.34.34,0,0,0,.14.29.34.34,0,0,0,.19.09h0a.42.42,0,0,0,.22,0l13.72-6.35a1,1,0,0,0,.56-.88v-3a.48.48,0,0,0-.22-.41.31.31,0,0,0-.13-.06.48.48,0,0,0-.35,0l-13.64,6.31a.87.87,0,0,0-.49.78Z",
    transform: "translate(-85.79 -65)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M172.42,225.09a.44.44,0,0,0-.29-.14Z",
    transform: "translate(-85.79 -65)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M157.93,231.57l4.56,2.1,16.07,7.42a.81.81,0,0,1,.33-.28l13.61-6.29a.48.48,0,0,1,.35,0l-20.43-9.4-.29-.14a.49.49,0,0,0-.26,0l-13.6,6.3A.84.84,0,0,0,157.93,231.57Z",
    transform: "translate(-85.79 -65)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M157.92,232.12v3.13l-.37.3h0l20.91,9.57a.37.37,0,0,1-.14-.3v-3.3a.78.78,0,0,1,.16-.49l-15.9-7.34-4.5-2.08A.88.88,0,0,0,157.92,232.12Z",
    transform: "translate(-85.79 -65)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M192.41,235.76v2a.56.56,0,0,1-.33.52l-13.76,6.3v-2.91l13.57-6.24A.37.37,0,0,1,192.41,235.76Z",
    transform: "translate(-85.79 -65)"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "92.53 176.6 71.76 167.02 71.76 170.22 92.53 179.66 92.53 176.6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M178.32,236.52v3.19a.34.34,0,0,0,.14.29.34.34,0,0,0,.19.09h0a.42.42,0,0,0,.22,0l13.72-6.35a1,1,0,0,0,.56-.88v-3a.48.48,0,0,0-.22-.41.31.31,0,0,0-.13-.06.48.48,0,0,0-.35,0l-13.64,6.31a.87.87,0,0,0-.49.78Z",
    transform: "translate(-85.79 -65)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M172.42,220a.44.44,0,0,0-.29-.14Z",
    transform: "translate(-85.79 -65)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M157.93,226.5l4.56,2.1L178.56,236a.81.81,0,0,1,.33-.28l13.61-6.29a.48.48,0,0,1,.35,0L172.42,220l-.29-.14a.49.49,0,0,0-.26,0l-13.6,6.3A.84.84,0,0,0,157.93,226.5Z",
    transform: "translate(-85.79 -65)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M187.81,228.73l-15-6.91a1.79,1.79,0,0,0-1.5,0l-8.43,3.9a.78.78,0,0,0,0,1.41l14.73,6.8a2,2,0,0,0,1.65,0l8.56-4A.69.69,0,0,0,187.81,228.73Z",
    transform: "translate(-85.79 -65)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M157.92,227.05v3.13l-.37.3h0l20.91,9.57a.37.37,0,0,1-.14-.3v-3.3a.78.78,0,0,1,.16-.49l-15.9-7.34-4.5-2.08A.88.88,0,0,0,157.92,227.05Z",
    transform: "translate(-85.79 -65)"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "92.53 171.53 71.76 161.95 71.76 165.15 92.53 174.59 92.53 171.53"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "107.37 164.86 93.27 171.48 93.27 174.33 107.37 167.82 107.37 164.86"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "95.04 172.37 93.88 172.9 94.46 175.33 94.84 174.31 95.67 174.62 95.04 172.37"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "106.58 172.03 105.41 172.55 105.99 174.98 106.37 173.97 107.2 174.28 106.58 172.03"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 303.41,
    cy: 248.42,
    rx: 46.91,
    ry: 15.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-90",
    cx: 303.41,
    cy: 248.42,
    rx: 46.65,
    ry: 15.19
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-91",
    cx: 303.41,
    cy: 248.42,
    rx: 46.39,
    ry: 14.98
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-92",
    cx: 303.41,
    cy: 248.42,
    rx: 46.13,
    ry: 14.76
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-93",
    cx: 303.41,
    cy: 248.42,
    rx: 45.87,
    ry: 14.55
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-94",
    cx: 303.41,
    cy: 248.42,
    rx: 45.61,
    ry: 14.34
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-95",
    cx: 303.41,
    cy: 248.42,
    rx: 45.36,
    ry: 14.12
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-96",
    cx: 303.41,
    cy: 248.42,
    rx: 45.1,
    ry: 13.91
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-97",
    cx: 303.41,
    cy: 248.42,
    rx: 44.84,
    ry: 13.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-98",
    cx: 303.41,
    cy: 248.42,
    rx: 44.58,
    ry: 13.48
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-99",
    cx: 303.41,
    cy: 248.42,
    rx: 44.32,
    ry: 13.27
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-100",
    cx: 303.41,
    cy: 248.42,
    rx: 44.06,
    ry: 13.06
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-101",
    cx: 303.41,
    cy: 248.42,
    rx: 43.81,
    ry: 12.84
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-102",
    cx: 303.41,
    cy: 248.42,
    rx: 43.55,
    ry: 12.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-103",
    cx: 303.41,
    cy: 248.42,
    rx: 43.29,
    ry: 12.42
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-104",
    cx: 303.41,
    cy: 248.42,
    rx: 43.03,
    ry: 12.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-105",
    cx: 303.41,
    cy: 248.42,
    rx: 42.77,
    ry: 11.99
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-106",
    cx: 303.41,
    cy: 248.42,
    rx: 42.51,
    ry: 11.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-107",
    cx: 303.41,
    cy: 248.42,
    rx: 42.26,
    ry: 11.56
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-108",
    cx: 303.41,
    cy: 248.42,
    rx: 42,
    ry: 11.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-109",
    cx: 303.41,
    cy: 248.42,
    rx: 41.74,
    ry: 11.14
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-110",
    cx: 303.41,
    cy: 248.42,
    rx: 41.48,
    ry: 10.92
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-111",
    cx: 303.41,
    cy: 248.42,
    rx: 41.22,
    ry: 10.71
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-112",
    cx: 303.41,
    cy: 248.42,
    rx: 40.96,
    ry: 10.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-113",
    cx: 303.41,
    cy: 248.42,
    rx: 40.71,
    ry: 10.28
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-114",
    cx: 303.41,
    cy: 248.42,
    rx: 40.45,
    ry: 10.07
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-115",
    cx: 303.41,
    cy: 248.42,
    rx: 40.19,
    ry: 9.86
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-116",
    cx: 303.41,
    cy: 248.42,
    rx: 39.93,
    ry: 9.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-117",
    cx: 303.41,
    cy: 248.42,
    rx: 39.67,
    ry: 9.43
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-118",
    cx: 303.41,
    cy: 248.42,
    rx: 39.41,
    ry: 9.22
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-119",
    cx: 303.41,
    cy: 248.42,
    rx: 39.16,
    ry: 9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-120",
    cx: 303.41,
    cy: 248.42,
    rx: 38.9,
    ry: 8.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-121",
    cx: 303.41,
    cy: 248.42,
    rx: 38.64,
    ry: 8.58
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-122",
    cx: 303.41,
    cy: 248.42,
    rx: 38.38,
    ry: 8.36
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-123",
    cx: 303.41,
    cy: 248.42,
    rx: 38.12,
    ry: 8.15
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-124",
    cx: 303.41,
    cy: 248.42,
    rx: 37.86,
    ry: 7.94
  }))), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M358.59,104.83V230.58a2.43,2.43,0,0,1-3.44,2.21L276,196.51a5.17,5.17,0,0,1-3-4.71V65.59Z",
    transform: "translate(-85.79 -65)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M276,67l80.76,37a3.17,3.17,0,0,1,1.86,2.89v9.77L273,77.4V68.88A2.11,2.11,0,0,1,276,67Z",
    transform: "translate(-85.79 -65)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M297.07,155.06l41.72,19.07a1.12,1.12,0,0,1,.66,1v.12a.94.94,0,0,1-1.33.86l-41.35-18.9a1.44,1.44,0,0,1-.83-1.3v-.15A.79.79,0,0,1,297.07,155.06Z",
    transform: "translate(-85.79 -65)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M290.93,160.73l47.86,21.94a1.12,1.12,0,0,1,.66,1v.12a.94.94,0,0,1-1.33.86L290.63,162.9a1.43,1.43,0,0,1-.83-1.29v-.16A.8.8,0,0,1,290.93,160.73Z",
    transform: "translate(-85.79 -65)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M290.93,169.27l47.86,21.93a1.15,1.15,0,0,1,.66,1v.12a.94.94,0,0,1-1.33.86l-47.49-21.77a1.43,1.43,0,0,1-.83-1.29V170A.79.79,0,0,1,290.93,169.27Z",
    transform: "translate(-85.79 -65)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M290.93,177.8l47.86,21.94a1.12,1.12,0,0,1,.66,1v.13a.94.94,0,0,1-1.33.85L290.63,180a1.44,1.44,0,0,1-.83-1.3v-.15A.8.8,0,0,1,290.93,177.8Z",
    transform: "translate(-85.79 -65)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M290.93,186.34l24.79,11.34a1.12,1.12,0,0,1,.66,1v.12a1,1,0,0,1-1.34.86l-24.41-11.16a1.44,1.44,0,0,1-.83-1.3v-.15A.8.8,0,0,1,290.93,186.34Z",
    transform: "translate(-85.79 -65)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M280.14,75.39c0,.55-.45.8-1,.56a1.76,1.76,0,0,1-1-1.45c0-.55.45-.8,1-.56A1.78,1.78,0,0,1,280.14,75.39Z",
    transform: "translate(-85.79 -65)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M283.57,76.91c0,.55-.45.8-1,.56a1.78,1.78,0,0,1-1-1.45c0-.55.45-.8,1-.56A1.76,1.76,0,0,1,283.57,76.91Z",
    transform: "translate(-85.79 -65)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M287,78.42c0,.56-.45.81-1,.56a1.74,1.74,0,0,1-1-1.44c0-.56.45-.81,1-.56A1.75,1.75,0,0,1,287,78.42Z",
    transform: "translate(-85.79 -65)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M345.77,160.61l-60-27.8a.91.91,0,0,1-.5-.73V85c0-.27.23-.39.5-.27l60,27.8a.9.9,0,0,1,.5.73v47.08C346.27,160.62,346.05,160.74,345.77,160.61Z",
    transform: "translate(-85.79 -65)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-129",
    x1: 202.68,
    y1: 33.69,
    x2: 257.32,
    y2: 59.01
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-130",
    x1: 202.68,
    y1: 40.38,
    x2: 257.32,
    y2: 65.71
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-131",
    x1: 202.68,
    y1: 47.08,
    x2: 257.32,
    y2: 72.4
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-132",
    x1: 202.68,
    y1: 53.78,
    x2: 257.32,
    y2: 79.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-133",
    x1: 202.68,
    y1: 60.47,
    x2: 257.32,
    y2: 85.8
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-134",
    x1: 202.68,
    y1: 67.17,
    x2: 257.32,
    y2: 92.49
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-135",
    x1: 202.68,
    y1: 73.87,
    x2: 257.32,
    y2: 99.19
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "222.65 74.45 216.22 71.47 216.22 61.19 222.65 64.17 222.65 74.45"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "232.75 79.14 226.32 76.16 226.32 58.91 232.75 61.88 232.75 79.14"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "242.85 83.82 236.42 80.84 236.42 55.91 242.85 58.89 242.85 83.82"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "252.95 88.5 246.53 85.52 246.53 55.87 252.95 58.85 252.95 88.5"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M307.77,145.67l-5.09-2.36a1.45,1.45,0,0,1-.67-1.24h0c0-.51.3-.79.67-.62l5.09,2.36a1.47,1.47,0,0,1,.67,1.24h0C308.44,145.56,308.13,145.84,307.77,145.67Z",
    transform: "translate(-85.79 -65)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M297.88,135l-4.57-2.11a1.68,1.68,0,0,1-.93-1.36h0c0-.52.42-.74.93-.5l4.57,2.12a1.66,1.66,0,0,1,.93,1.36h0C298.81,135,298.39,135.22,297.88,135Z",
    transform: "translate(-85.79 -65)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M298.14,125.75l-5.09-2.36a1.45,1.45,0,0,1-.67-1.24h0c0-.51.3-.79.67-.62l5.09,2.36a1.47,1.47,0,0,1,.67,1.24h0C298.81,125.64,298.5,125.92,298.14,125.75Z",
    transform: "translate(-85.79 -65)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M298.14,116.4,293.05,114a1.45,1.45,0,0,1-.67-1.24h0c0-.51.3-.79.67-.62l5.09,2.36a1.47,1.47,0,0,1,.67,1.24h0C298.81,116.29,298.5,116.57,298.14,116.4Z",
    transform: "translate(-85.79 -65)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M297.88,106.92l-4.57-2.12a1.67,1.67,0,0,1-.93-1.36h0c0-.51.42-.73.93-.5l4.57,2.12a1.68,1.68,0,0,1,.93,1.36h0C298.81,106.93,298.39,107.16,297.88,106.92Z",
    transform: "translate(-85.79 -65)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M317.61,150.23,313,148.11a1.68,1.68,0,0,1-.93-1.36h0c0-.51.42-.73.93-.5l4.57,2.12a1.68,1.68,0,0,1,.93,1.36h0C318.54,150.24,318.12,150.47,317.61,150.23Z",
    transform: "translate(-85.79 -65)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M327.71,154.91l-4.57-2.12a1.67,1.67,0,0,1-.93-1.36h0c0-.51.42-.73.93-.5l4.57,2.12a1.68,1.68,0,0,1,.93,1.36h0C328.64,154.92,328.22,155.15,327.71,154.91Z",
    transform: "translate(-85.79 -65)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M337.81,159.59l-4.57-2.12a1.67,1.67,0,0,1-.93-1.36h0c0-.51.42-.73.93-.5l4.57,2.12a1.68,1.68,0,0,1,.93,1.36h0C338.74,159.6,338.32,159.83,337.81,159.59Z",
    transform: "translate(-85.79 -65)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M379.92,150s-9.25,27.69-10.69,27.9-18.93-8.13-18.93-8.13-3.5.41-4.53,3.5a30.15,30.15,0,0,0-1.13,3.81s24.59,15.45,27.68,14.72,13.42-15.26,13.42-15.26Z",
    transform: "translate(-85.79 -65)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M378.58,295.21s-1.42,4-4,5.82-9.6,5.78-6.4,8,7.74,2.89,11.35-.62,2.79-5.06,7.33-6,4.2-2.14,4.1-4.62a6.44,6.44,0,0,0-1.19-3.73S387.68,298,378.58,295.21Z",
    transform: "translate(-85.79 -65)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M406.72,303.63s-1.55,5.54-4.23,7.17-6.66,3.76-7.12,6.63,5.47,4.32,10,1.82,2.13-1.61,5.66-5.47c2.77-3,7-3.55,6.91-6s-.48-5.89-.48-5.89S411.42,306.82,406.72,303.63Z",
    transform: "translate(-85.79 -65)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M339.6,172.58l-4.36-27.53a1.16,1.16,0,0,1,.86-1.31h0a1.16,1.16,0,0,1,1.43.95l4.41,27.89Z",
    transform: "translate(-85.79 -65)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M349.27,170s-1.07-4.67-2.59-5.34a58.8,58.8,0,0,0-6.57-1.76s-1.58,1.94,1,2.74l2.56.79a13.16,13.16,0,0,0-4.26,0c-3.1.34-2.64,2-2.06,6.91s1.64,5.59,3,5.35a21.24,21.24,0,0,0,4.35-2.07S346.32,171.59,349.27,170Z",
    transform: "translate(-85.79 -65)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M377.39,211.12v47.3s.34,10,1,17.12-.17,20.18-.17,20.18.34,2.71,6.27,1.36,5.26-3.06,5.26-3.06,1-7.46,2.37-18.31,0-13.9,0-13.9l8.82-41.2Z",
    transform: "translate(-85.79 -65)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M393.67,219.93l3.27,36.7a34.49,34.49,0,0,0,2.43,13,58.33,58.33,0,0,1,3.89,13.83c1.43,9.07,2.28,20.09,2.28,20.09s-.08,1.77,6.07,1.56,6.31-3.26,6.31-3.26,1.18-5.59,1-18.31S415.88,263,415.88,263s.85-15.77,2-28-2.21-16.44-2.21-16.44A75.14,75.14,0,0,1,393.67,219.93Z",
    transform: "translate(-85.79 -65)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M389.33,146.69s29,8.08,33.41,12.36.09,42.74-1.34,43.89-3.48,2.92-3.48,2.92v11.31a4.68,4.68,0,0,1-3.23,4.45c-5,1.64-15.16,4.19-24.41,1.87-13-3.24-12.88-12.33-12.88-12.33s.38-53.44,1.14-57.73S383.8,146.22,389.33,146.69Z",
    transform: "translate(-85.79 -65)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M422.74,159.05s-11.5-1-9.3,11.4c1.71,9.58,6.48,24.14,5.27,24.86s-21.21,10.42-21.21,10.42,3,1.35,3.53,4.24,0,3,0,3,30.53-9.45,31.46-11.42S427.08,160.91,422.74,159.05Z",
    transform: "translate(-85.79 -65)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M406.49,140.46l0,11.86s-3.75,3.61-8.62,3.69-4.39-3.21-4.39-3.21v-7.21Z",
    transform: "translate(-85.79 -65)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M406.53,151.78l-10.15,3.89L401,159.4l8.91-6.42S409,150.07,406.53,151.78Z",
    transform: "translate(-85.79 -65)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    className: "cls-53",
    d: "M393.52,152l1.68,3.32-4.42.91V149.4S392.5,151.69,393.52,152Z",
    transform: "translate(-85.79 -65)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M388.4,130.67s.29,12.56.69,15.12,3.45,6.31,5.11,6.44a10.79,10.79,0,0,0,10-5.65c2.7-5.27,6.73-9.84,3.56-14.79s-7.94-3.94-11.18-4S388.4,130.67,388.4,130.67Z",
    transform: "translate(-85.79 -65)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M385.69,128.79s.36,4.46,7.66,4.9,8.22-1,8.22-1-1.07,3.23.49,4.37,1,3.7,1.77,3.66.7-5,2.29-5.08,1.43,2.44.5,4.5-.74,3.81.29,3.14,4.36-3.58,5.44-9.51-3.52-8-3.52-8,.31-5.75-5-6.33S386.41,125.26,385.69,128.79Z",
    transform: "translate(-85.79 -65)"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "309.27 90.3 306.47 91 307.26 91.42 300.43 144.37 303.47 147.89 308.41 145.07 311.29 92.05 312.32 92.19 310.7 90.66 309.27 90.3"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M398.25,206.15a19.66,19.66,0,0,0-5.16-.19,14.21,14.21,0,0,0-3.69,1.19s-1.27,1.23,1.19,1a8.68,8.68,0,0,1,3.07,0,14.9,14.9,0,0,1-5.36,2.14c-2.84.42-2.46,2.59-1.1,2.88s-.72,1.66.21,2.38.93,1.78,2.5,2.59,3.44,1.61,5.22,0,6.12-5.9,6.12-5.9S401.88,207.5,398.25,206.15Z",
    transform: "translate(-85.79 -65)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLecturing);
export default __webpack_public_path__ + "static/media/lecturing.00b014a364c118c27baae8fbe3b84709.svg";
export { ForwardRef as ReactComponent };